
import React from 'react';
import { cn } from '@/lib/utils';

interface PerformanceChartLegendProps {
  payload: any[];
  hiddenLines: string[];
  onLegendClick: (dataKey: string) => void;
}

const PerformanceChartLegend: React.FC<PerformanceChartLegendProps> = ({ 
  payload, 
  hiddenLines, 
  onLegendClick 
}) => {
  return (
    <ul className="flex flex-wrap justify-center gap-4 mt-2">
      {payload.map((entry: any, index: number) => (
        <li 
          key={`item-${index}`}
          className={cn(
            "flex items-center gap-2 cursor-pointer px-2 py-1 rounded transition-colors",
            hiddenLines.includes(entry.dataKey) 
              ? "opacity-50" 
              : "hover:bg-gray-100 dark:hover:bg-gray-800"
          )}
          onClick={() => onLegendClick(entry.dataKey)}
        >
          <span 
            className="inline-block w-3 h-3 rounded-full" 
            style={{ backgroundColor: entry.color }}
          />
          <span className="text-sm">{entry.value}</span>
        </li>
      ))}
    </ul>
  );
};

export default PerformanceChartLegend;
